import * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import { AtomButton, type SidebarButtonProps, Tooltip, useSidebarItem } from '@gitbook/spine-react';

import { useFeedbackButton } from '../../Components';

export function FeedbackSidebarButton(
    props: Pick<SidebarButtonProps, 'outlined' | 'iconOnly' | 'label'>
) {
    const { label = 'Feedback', outlined = false, iconOnly = false } = props;

    const { isEnabled, buttonProps } = useFeedbackButton({
        flagKey: 'APP_WIDE_FEEDBACK',
    });
    const { itemProps } = useSidebarItem({
        iconOnly,
        outlined,
        icon: Icon.Happy,
        label,
        elementType: 'button',
    });
    const isExpanded = buttonProps['aria-expanded'] === true;
    const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);

    React.useEffect(() => {
        if (isExpanded) {
            setIsTooltipOpen(false);
        }
    }, [isExpanded]);

    if (!isEnabled) {
        return null;
    }

    return (
        <Tooltip
            label={label}
            disabled={!iconOnly}
            isOpen={isTooltipOpen}
            onOpenChange={(open) => setIsTooltipOpen(isExpanded ? false : open)}
        >
            <AtomButton {...itemProps} {...buttonProps} className={itemProps.className} />
        </Tooltip>
    );
}
